import { createSelector } from '@reduxjs/toolkit';

import type { CompanySerialized, PermsSerialized, UserFullSerialized } from '@playq/octopus2-auth';
import { Company, Perms, UserFull, UserRole } from '@playq/octopus2-auth';

import type { RootState } from '/store/RootState';

export const baseSelectors = {
  state: (state: RootState) => state.auth,
  tokensSerialized: (state: RootState) => state.auth.tokens,
  userSerialized: (state: RootState) => state.auth.user,
  companySerialized: (state: RootState): CompanySerialized => state.auth.company,
  role: (state: RootState): UserRole => state.auth.role,
  loggedIn: (state: RootState): boolean => state.auth.loggedIn,
  isServicesAuthorizationSet: (state: RootState): boolean => state.auth.isServicesAuthorizationSet,
  error: (state: RootState): string | undefined => state.auth.error,
  pending: (state: RootState): boolean => state.auth.pending,
  rememberMe: (state: RootState): boolean => state.auth.rememberMe,
  companyPermsSerialized: (state: RootState): PermsSerialized => state.auth.companyPerms,
  googleRedirectURL: (state: RootState): string | undefined => state.auth.googleRedirectURL,
  loginRedirectURL: (state: RootState): string | undefined => state.auth.loginRedirectURL,
};

export const selectUser = createSelector(baseSelectors.userSerialized, (user: UserFullSerialized | undefined) =>
  user?.id ? new UserFull(user) : undefined
);

export const isAdmin = createSelector(
  baseSelectors.role,
  (role: UserRole) => role === UserRole.Admin || role === UserRole.SuperAdmin
);

export const company = createSelector(baseSelectors.companySerialized, (c: CompanySerialized) =>
  c?.id ? new Company(c) : undefined
);

export const companyID = createSelector(baseSelectors.companySerialized, (c: CompanySerialized) =>
  c?.id ? c.id : undefined
);

export const companyPerms = createSelector(baseSelectors.companyPermsSerialized, (p: PermsSerialized) => new Perms(p));
